import React from "react";
import { Link } from "react-router-dom";
import { FaFacebookF, FaTwitter, FaVimeoV, FaInstagram, FaPhoneAlt, FaEnvelope, FaMapMarkerAlt } from "react-icons/fa";
import "./TopHeader.css";

export default function TopHeader() {
  return (
    <div className="top-header">
      <div className="container">
        <div className="top-header-inner">
          <div className="top-left">
            <ul>
              <li>
                <FaMapMarkerAlt className="icon" /> Maharashtra
              </li>
              <li>
                <FaPhoneAlt className="icon" /> <a href="tel:+919152023390">+91 91520 23390</a>
              </li>
              <li>
                <FaEnvelope className="icon" />{" "}
                <a href="mailto:Info@riyanshsolar.com">
                  Info@riyanshsolar.com
                </a>
              </li>
            </ul>
          </div>
          <div className="top-right">
            <ul className="social-links">
              <li><Link to="https://www.facebook.com/riyanshsolarpowerplus" target="blank"><FaFacebookF /></Link></li>
              <li><Link to="/" target="blank"><FaTwitter /></Link></li>
              {/* <li><Link to="/" target="blank"><FaVimeoV /></Link></li> */}
              <li><Link to="https://www.instagram.com/official_riyanshsolarpowerplus/#" target="blank"><FaInstagram /></Link></li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
}
